import { sceneHelper } from '../helper/scene-helper';
import { resolveCmsDevProxyUrl } from '../cms-dev-proxy-url';
import { collectVideoElementsFromObject } from './stop-playback-implementation';

function waitForVideoEnded(video: HTMLVideoElement): Promise<void> {
  if (video.loop) return Promise.resolve();
  if (video.ended) return Promise.resolve();
  return new Promise<void>((resolve) => {
    const done = () => {
      video.removeEventListener('ended', done);
      resolve();
    };
    video.addEventListener('ended', done, { once: true });
  });
}

async function playVideoElement(video: HTMLVideoElement, url?: string) {
  if (url) {
    video.src = url;
    video.load();
  }
  try {
    await video.play();
  } catch (error) {
    console.warn('Video playback blocked or failed:', error);
    return;
  }
  await waitForVideoEnded(video);
}

export async function runPlayVideoImplementation(data: {
  target?: { id?: string };
  video?: { url?: string };
}) {
  const targetId = data?.target?.id;
  if (!targetId) return;

  const targetObject = sceneHelper?.getObjectByUUID(targetId);
  if (!targetObject) return;

  const videoElements = new Set<HTMLVideoElement>();
  collectVideoElementsFromObject(targetObject, videoElements);
  if (videoElements.size === 0) return;

  const url = data.video?.url
    ? resolveCmsDevProxyUrl(data.video.url) ?? data.video.url
    : undefined;

  await Promise.all([...videoElements].map((video) => playVideoElement(video, url)));
}
